{
  "collapse": "Contraer",
  "columnResizer": "Redimensionador de columnas",
  "drag": "Arrastrar",
  "expand": "Ampliar",
  "loading": "Cargando…",
  "loadingMore": "Cargando más…",
  "resizeColumn": "Cambiar el tamaño de la columna",
  "sortAscending": "Orden ascendente",
  "sortDescending": "Orden descendente"
}
